import React from 'react';

export default function MultiInputType(_props) {
    return <></>;
}